const dependencyMap = new Map();
let preRegisteredComponents = [];

/**
 * Cache dependency
 */
export const registerDependency = componentName => {
  if (!dependencyMap.get(componentName) && preRegisteredComponents.indexOf(componentName) < 0) {
    preRegisteredComponents.push(componentName);
    return;
  }
  for (const [key, callback] of dependencyMap) {
    if (key === componentName) {
      callback();
      break;
    }
  }
};

/**
 * Invoke callback upon dependency registration
 */
export const onDependencyRegistration = (componentName, callback) => {
  preRegisteredComponents = preRegisteredComponents.filter(component => {
    if (component === componentName) {
      callback();
      return false;
    }
    return true;
  });
  dependencyMap.set(componentName, callback);
};
//# sourceMappingURL=ServiceDependencies.js.map